<template>
  <b-container fluid>
    <div align="center">
      <img src="./assets/crclogo.png"/>
      <!--<b-button v-if="authenticated" class="mt-2 ml-2 position-absolute" style="left: 5px;" @click="reloadPage" variant="primary">Log-Out</b-button>-->
      <b-button v-if="isAdmin" class="mt-2 ml-2 position-absolute" style="right: 5px;" v-b-modal.editTable @click="getCurrentUrls" variant="success">Admin - Edit List</b-button>
      <!--<b-button v-if="authenticated && isMember" class="mt-2 ml-2 fixed-top" @click="reloadPage" variant="info">Log-Out</b-button>-->
    </div>
    <b-toast id="yes" toaster="b-toaster-top-left" title="Authentication Successful" variant="success">
    </b-toast>
    <b-toast id="no" toaster="b-toaster-top-left" title="Access Denied" variant="danger">
      Username or Password are incorrect.
    </b-toast>
    <b-toast id="employee" toaster="b-toaster-top-left" title="Access Denied" variant="warning">
      This portal is only accessible to currently enrolled students.
    </b-toast>
    <b-row>
      <b-col cols="3"></b-col>
      <b-col cols="6">
        <div class="introdiv" v-if="!authenticated" style="text-align: center"><!--<b>Welcome to the</b>
          <h2>CRC Student Appointment Center</h2>
          <p>Please login below to access all CRC student appointment scheduling.<br><br>
            <i><span style="font-size: 12px"><b>Please note:</b> After October 1st 2021 all on-campus and in-person appointments will
              require you, the student, <a href="https://crc.losrios.edu/campus-life/covid-19-updates/covid-vaccine-requirements" target="_blank">to be vaccinated against COVID-19 or obtain an exception.</a>
              Your proof of vaccination can be uploaded in <a href="https://ps.losrios.edu/psp/student/?cmd=login" target="_blank">your e-Services account</a> and, upon verification, you will be cleared to be on-campus.
              You can check your vaccination status in <a href="https://ps.losrios.edu/psp/student/?cmd=login" target="_blank">your e-Services account</a>.<br>
              Students who are not cleared can only make appointments for services that are provided online.</span></i>
          </p>-->
          <span v-html="authtext"></span>
        </div>
        <div v-if="authenticated && !isMember" style="text-align: center">
          <!--<h2>Schedule Online Appointments</h2>
          <p class="introdiv">Please select the <b>online service appointment</b> you wish to make from the list below.<br><br>
            <i><span style="font-size: 12px">Our records indicate that you are not cleared to make on-ground and in-person appointments.
              To make on-campus and in-person appointments you must <a href="https://crc.losrios.edu/campus-life/covid-19-updates/covid-vaccine-requirements" target="_blank">provide proof of COVID-19 vaccination or obtain an exemption.</a>
              If you feel you are seeing this page in error, please check your vaccination record status in <a href="https://ps.losrios.edu/psp/student/?cmd=login" target="_blank">your e-Services account</a>.<br>
              If you haven’t already done so, you may upload your proof of vaccine in <a href="https://ps.losrios.edu/psp/student/?cmd=login" target="_blank">your e-Services account</a> to obtain cleared status and be able to make on-campus and in-person appointments.
            </span><br></i>
          </p>-->
          <span v-html="notcleartext"></span>
          <b-button class="speciallink" href="https://ps.losrios.edu/psp/student/?cmd=login" size="sm" target="_blank" variant="primary">Upload your Vaccine Record via e-Services</b-button>
        </div>
        <div class="introdiv" v-if="authenticated && isMember" style="text-align: center">
          <!--<h2>Schedule All CRC Services Appointments</h2>
          <p>Please select the <b>service appointment</b> you wish to make from the list below.<br><br>
            <i><span style="font-size: 12px">Our records indicate that you are cleared to make on-ground and in-person appointments as per our
              <a href="https://crc.losrios.edu/campus-life/covid-19-updates/covid-vaccine-requirements" target="_blank">COVID vaccine requirements.</a>
              – thank you!<br>You can at any time check your vaccination record status in <a href="https://ps.losrios.edu/psp/student/?cmd=login" target="_blank">your e-Services account</a>.
            </span><br></i>
          </p>-->
          <span v-html="cleartext"></span>
        </div>
      </b-col>
      <b-col cols="3"></b-col>
    </b-row>
    <b-row>
      <b-col cols="2">

      </b-col>
      <b-col cols="8">
        <Authenticate v-if="!authenticated" @inStudentsGroup="setStudent" @dname="setDName" @allowed="setMember" @authenticated="setAuth" @uname="setUser" @pswd="setPsw" class="mt-3"></Authenticate>
        <div v-if="authenticated && !isMember && inStudentsGroup"><contenttable :items="items" mode="Online"></contenttable></div>
        <div v-if="authenticated && isMember"><contenttable :items="items" mode=""></contenttable></div>
      </b-col>
      <b-col cols="2">

      </b-col>
    </b-row>
    <div class="spacer-div"></div>
    <b-row>
      <b-col cols="12">
      <div class="footer-secondary">
        <div class="container">
          <div class="md-max-width">
            <div class="row">
              <div class="col-xs-6 col-sm-3"><span class="footer-header"><a href="https://crc.losrios.edu/campus-life/clubs-and-student-leadership" class="white-text" title="Students">Students</a></span>
                <ul>
                  <li>
                    <a href="https://crc.losrios.edu/admissions/get-started-and-apply/future-student-faq" title="Future Student FAQ">Future Student FAQ</a>
                  </li>
                  <li>
                    <a href="https://crc.losrios.edu/admissions/enroll-in-classes" title="Enroll in Classes">Enroll in Classes</a>
                  </li>
                  <li>
                    <a href="https://crc.losrios.edu/academics/career-and-academic-communities" title="Career and Academic Communities">Career and Academic Communities</a>
                  </li>
                  <li>
                    <a href="https://crc.losrios.edu/academics/search-class-schedules" title="Search Class Schedules">Search Class Schedules</a>
                  </li>
                  <li>
                    <a href="https://ps.losrios.edu/student/signon.html" target="_blank" title="eServices">eServices</a>
                  </li>
                  <li>
                    <a href="https://crc.losrios.edu/academics/online-education" title="Online Education">Online Education</a>
                  </li>
                </ul>
              </div>
              <div class="col-xs-6 col-sm-3"><span class="footer-header"><a href="https://crc.losrios.edu/student-resources" class="white-text" title="Resources">Resources</a></span>
                <ul>
                  <li>
                    <a href="https://crc.losrios.edu/student-resources/support-services" title="Student Support Services">Student Support Services</a>
                  </li>
                  <li>
                    <a href="https://crc.losrios.edu/student-resources/library" title="Library">Library</a>
                  </li>
                  <li>
                    <a href="https://crc.losrios.edu/admissions/get-started-and-apply/admissions-and-records/advanced-education" title="Advanced Education">Advanced Education</a>
                  </li>
                  <li>
                    <a href="https://crc.losrios.edu/admissions/get-started-and-apply/admissions-and-records/order-transcripts" title="Order Transcripts">Order Transcripts</a>
                  </li>
                  <li>
                    <a href="https://crc.losrios.edu/student-resources/support-services/veterans-resource-center" title="Veterans Resource Center">Veterans Resource Center</a>
                  </li>
                  <li>
                    <a href="https://crc.losrios.edu/about-us/our-facilities/elk-grove-center" title="Elk Grove Center">Elk Grove Center</a>
                  </li>
                </ul>
              </div>
              <div class="col-xs-6 col-sm-3"><span class="footer-header"><a href="https://crc.losrios.edu/about-us/contact-us" class="white-text" title="Information">Information</a></span>
                <ul>
                  <li>
                    <a href="https://crc.losrios.edu/campus-life/student-jobs" title="Student Jobs">Student Jobs</a>
                  </li>
                  <li>
                    <a href="https://www.losrios.edu/pr" target="_blank" title="Policies and Regulations">Policies and Regulations</a>
                  </li>
                  <li>
                    <a href="https://crc.losrios.edu/about-us/contact-us/faculty-and-staff-directory" title="Faculty and Staff Directory">Faculty and Staff Directory</a>
                  </li>
                  <li>
                    <a href="https://crc.losrios.edu/about-us/our-facilities/public-facility-rentals" title="Facility Rentals">Facility Rentals</a>
                  </li>
                  <li>
                    <a href="https://crc.losrios.edu/campus-life/health-and-safety/sexual-violence-and-title-ix" title="Sexual Violence and Title IX">Sexual Violence and Title IX</a>
                  </li>
                  <li>
                    <a href="https://crc.losrios.edu/about-us/our-values/student-rights-and-responsibilities" title="Student Rights and Responsibilities">Student Rights and Responsibilities</a>
                  </li>
                </ul>
              </div>
              <div class="col-xs-6 col-sm-3"><span class="footer-header"><a href="https://losrios.edu" target="_blank" class="white-text" title="Los Rios">Los Rios</a></span>
                <ul>
                  <li>
                    <a href="https://losrios.edu/about-us/board-of-trustees" target="_blank" title="Board of Trustees">Board of Trustees</a>
                  </li>
                  <li>
                    <a href="https://losrios.edu/community/doing-business-with-los-rios" target="_blank" title="Doing Business with Los Rios">Doing Business with Los Rios</a>
                  </li>
                  <li>
                    <a href="https://employees.losrios.edu" target="_blank" title="Employee Resources">Employee Resources</a>
                  </li>
                  <li>
                    <a href="https://jobs.losrios.edu" target="_blank" title="Jobs at Los Rios">Jobs at Los Rios</a>
                  </li>
                  <li>
                    <a href="https://foundation.losrios.edu" target="_blank" title="Los Rios Colleges Foundation">Los Rios Colleges Foundation</a>
                  </li>
                  <li>
                    <a href="https://police.losrios.edu" target="_blank" title="Los Rios Police Department">Los Rios Police Department</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      </b-col>
    </b-row>
    <b-modal size="xl" id="editTable" no-close-on-backdrop no-close-on-esc hide-footer>
      <editables @newrow="getCurrentUrls" @gottext="getApptText" :authtext="authtext" :notcleartext="notcleartext" :cleartext="cleartext" :auth="encodedUserPsw" :fields="fields" :items="items"></editables>
    </b-modal>
  </b-container>
</template>

  <script>
import Authenticate from "@/components/Authenticate";
import contenttable from "@/components/contenttable";
import editables from "@/components/editables";
export default {
  name: 'App',
  data(){
    return{
      username:"",
      password:"",
      displayName:"",
      authenticated:false,
      isMember:true,
      isAdmin:false,
      cleartext:"",
      notcleartext:"",
      inStudentsGroup:true,
      authtext:"",
      fields:[
        {key:'department',label:'Program or Department'},
        {key:'service',label:"Service"},
        {key:'url',label:'URL'},
        {key:'type',label:'On-Campus / Online'},
      ],
      items:[],
    }
  },
  components: {
    Authenticate,
    contenttable,
    editables,
  },
  methods:{
    setDName(value){
      this.displayName = value;
    },
    setPsw(value){
      this.password = value;
    },
    setStudent(value){
      this.inStudentsGroup = value;
    },
    setUser(value){
      this.username = value;
    },
    setAuth(value){
      this.authenticated = value;
/*
      if((this.authenticated && this.inStudentsGroup) || (this.authenticated && !this.inStudentsGroup && this.isMember)){
*/
      if(this.authenticated){
        this.$root.$bvToast.show('yes');
        this.inStudentsGroup = true;
        this.isMember = true;
        this.checkAdmin();
      }
      /*else if(this.authenticated && !this.inStudentsGroup && !this.isMember){
        this.authenticated = false;
        this.$root.$bvToast.show('employee');
      }*/
      else{
        this.$root.$bvToast.show('no');
      }
    },
    setMember(value){
      this.isMember = value;
    },
    reloadPage(){
      location.reload();
    },
    getCurrentUrls(){
      let url = 'https://services.crc.ad.losrios.edu/CalmsPublicApi/api/operations/getUrls';
      this.$http.get(url,{
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': this.encodedAuth,
          'Access-Control-Allow-Origin': '*',
          'access-control-allow-credentials': 'true'
        }
      }).then((result) => {
        this.items = result.data;
      });
    },
    getApptText(){
      let url = 'https://services.crc.ad.losrios.edu/CalmsPublicApi/api/operations/getApptText';
      this.$http.get(url,{
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': this.encodedAuth,
          'Access-Control-Allow-Origin': '*',
          'access-control-allow-credentials': 'true'
        }
      }).then((result) => {
        this.authtext = result.data[1];
        this.cleartext = result.data[2];
        this.notcleartext = result.data[3];
      });
    },
    checkAdmin(){
      if(this.username.length === 8) {
        const formData = new FormData();
        formData.append("user", this.username);
        formData.append("pass", this.password);
        formData.append("userdomain", "lrccd.ad.losrios.edu");
        formData.append("groupdomain", "crc.ad.losrios.edu");
        formData.append("group", "CRCAppointments-Editors");
        let urlReq = 'https://services.crc.ad.losrios.edu/CalmsPublicApi/api/operations/selfAssess';
        this.$http.post(urlReq, formData, {
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': this.encodedAuth,
            'Access-Control-Allow-Origin': '*',
            'access-control-allow-credentials': 'true'
          }
        }).then((result) => {
          this.isAdmin = result.data.isMember;
        });
      }
    }
  },
  mounted(){
    this.getCurrentUrls();
    this.getApptText();
  },
  computed:{
    encodedUserPsw(){
      let encoded = btoa("lrccd\\"+this.username+":"+this.password);
      return "Basic "+encoded;
    },
    encodedAuth(){
      let encoded = "Y3JjXHN2Yy1jYWxtczpzMzNteWxAYnM=";
      return "Basic "+encoded;
    },
  }
}
</script>

<style>
  .footer-secondary{
    background-color: #00263d;
    bottom:0;
  }
  .footer-secondary a{
    color:white;
  }
  .footer-header{
    display: block;
    font-family: 'brandon-grotesque','Arial',sans-serif;
    font-size:2rem;
    font-weight: 200;
    margin:0 0 .5em;
    text-transform: uppercase;
  }
  ul{
    list-style: none;
    margin:0;
    padding: 0;
  }
  .footer-secondary ul a{
    color:white;
  }
  .footer-secondary ul li{
    margin:0 0 0.7rem;
    padding:0;
  }
  .md-max-width{
    margin-right: 0;
    max-width: 100%;
  }
  .bg{
    background-color: #00263d;
  }
  .introdiv a:visited{
    color:rebeccapurple;
  }
  .spacer-div{
    min-height: 300px;
  }
</style>
